import { t } from 'i18next';
import { VirtualBackgroundMenuItem } from 'features/VirtualBackground/components/VirtualBackgroundMenuItem/VirtualBackgroundMenuItem';
import { isFeatureOn } from 'useCase/featureFlags/featureFlagsApi';
import { FEATURES } from 'consts';
import { SoundAndCameraSettingsMenuItem } from 'features/Modals/SoundSettingsModal/components/SoundAndCameraSettingsMenuItem/SoundAndCameraSettingsMenuItem';
import { MenuItem } from '../ControlButtonMenu/ControlButtonMenu';

interface BuildMenuProps {
    isAdvanced: boolean;
    videoDevices: MediaDeviceInfo[];
    videoDeviceId?: string;
}

interface ExcludeDefaultDeviceProps {
    devices: MediaDeviceInfo[];
    currentDeviceId?: string;
}
const getDevicesWithActiveStatus = ({ devices, currentDeviceId }: ExcludeDefaultDeviceProps) => {
    return devices.map(({ deviceId, label }, i) => {
        const isDefault = i === 0 && !currentDeviceId;
        const active = deviceId === currentDeviceId || isDefault;

        return { type: 'label', text: label, active };
    });
};

export const buildMenu = ({ isAdvanced, videoDevices, videoDeviceId }: BuildMenuProps) => {
    const mappedVideoDevices = getDevicesWithActiveStatus({ devices: videoDevices, currentDeviceId: videoDeviceId });

    if (isAdvanced) {
        const isVirtualBackgroundsEnabled = isFeatureOn(FEATURES.VCS_VIRTUAL_BACKGROUNDS_ENABLED);

        return [
            ...(mappedVideoDevices.length > 0
                ? [{ type: 'title', text: t('vks_microphone_camera') }, ...mappedVideoDevices]
                : []),
            isVirtualBackgroundsEnabled
                ? {
                      type: 'menu',
                      element: VirtualBackgroundMenuItem,
                      fullWidth: true,
                      withSeparator: mappedVideoDevices.length > 0,
                  }
                : null,
            {
                type: 'menu',
                element: SoundAndCameraSettingsMenuItem,
                fullWidth: true,
                withSeparator: mappedVideoDevices.length > 0 || isVirtualBackgroundsEnabled,
            },
        ].filter(Boolean) as MenuItem[];
    }

    return [...(mappedVideoDevices.length > 0 ? mappedVideoDevices : [])].filter(Boolean) as MenuItem[];
};
